import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ArrowUp } from "lucide-react";

const ScrollToTop = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.5, y: 20 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.5, y: 20 }}
          whileHover={{ scale: 1.1, backgroundColor: "var(--cream)" }}
          whileTap={{ scale: 0.9 }}
          onClick={scrollToTop}
          className="fixed bottom-8 right-8 z-[100] w-12 h-12 rounded-full flex items-center justify-center shadow-2xl group"
          style={{
            background: "rgba(228,199,122,0.15)",
            border: "1px solid rgba(228,199,122,0.45)",
            backdropFilter: "blur(12px)",
          }}
          aria-label="Scroll to top"
        >
          <ArrowUp 
            size={20} 
            color="#e4c77a" 
            className="group-hover:text-[var(--ink)] transition-colors duration-300" 
          />
          
          {/* Subtle glow pulse */}
          <div className="absolute inset-0 rounded-full animate-pulse opacity-30" style={{ boxShadow: "0 0 20px var(--gold)" }} />
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollToTop;
